module.exports = __webpack_public_path__ + "static/media/walkthrough-white.ccee2a48.svg";